import { AiAssistantProductCardProps } from '../../ProductCard/AiAssistantProductCard';
import { AiAssistantRecommendedProductsMessage } from '../types';

type RecommendedVariantsList = Omit<
    AiAssistantProductCardProps,
    'isAddToCartEnabled' | 'messageId'
>[];

const getRecommendedVariantsList = (
    products: AiAssistantRecommendedProductsMessage['products'],
): RecommendedVariantsList => {
    const recommendedProducts: RecommendedVariantsList = [];

    products.forEach((product) => {
        product.variants
            .filter((variant) => variant.is_recommended)
            .forEach((recommendedVariant) => {
                recommendedProducts.push({
                    id: recommendedVariant.variant_id,
                    title: product.title,
                    price: recommendedVariant.price,
                    basePrice: recommendedVariant.base_price,
                    currency: recommendedVariant.currency,
                    imageUrl: recommendedVariant.image_url,
                    url: recommendedVariant.url,
                });
            });
    });

    return recommendedProducts;
};

export default getRecommendedVariantsList;
